module.exports = __webpack_public_path__ + "img/icon-cheshire.5162f260.png";